<script lang="ts" setup>
import helpers from '~/helpers'
import type { CategoryData } from '~/types/categories'

const props = defineProps<{
  categoryData: CategoryData
}>()

async function routeTo (): Promise<void> {
  await navigateTo(helpers.getCategoryPath(props.categoryData))
}
</script>

<template>
  <a
    class="
      flex min-h-[68px] items-center rounded-2xl bg-main-very-light-gray px-5 py-1 !no-underline md:min-h-[78px]
    "
    href="#"
    @click.prevent="routeTo"
  >
    <span class="text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal">
      {{ categoryData.attributes.name }}
    </span>

<!--  TODO: IMG!  -->
  </a>
</template>
